// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import type {PaymentProvider} from '../../../../entities';
import type {ProcessorParameters} from '../../api';

type Props = {
  selectedCard: string,
  paymentProvider: PaymentProvider,
  paymentSettings: {
    title: string,
    currency: string,
    description: string,
    amount: string,
  },
  watch: string => string,
  disabled?: boolean,
  onSubmit: (processorParameters: ProcessorParameters) => void,
};

const useStyles = makeStyles(theme => ({
  confirmButton: {
    zIndex: 1,
    height: 48,
    margin: theme.spacing(1, 0),
    fontWeight: 600,
    fontSize: '1.125rem',
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      left: 0,
      bottom: 64,
      margin: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(4)})`,
    },
  },
}));

export default function CulqiPaymentButton(props: Props) {
  const {
    paymentProvider,
    paymentSettings,
    watch,
    disabled,
    onSubmit,
    selectedCard,
  } = props;

  const classes = useStyles();

  const handleClick = e => {
    e.persist();
    if (selectedCard && selectedCard !== 'NEW') {
      onSubmit({
        culqi: {
          phone: watch('phone') || '',
          sourceId: '',
        },
        name: 'culqi',
      });
    } else openCulqi(e);
  };

  const openCulqi = e => {
    if (window.Culqi) {
      window.Culqi.publicKey = paymentProvider.serverParameters
        ? paymentProvider.serverParameters.publicKey
        : '';
      const culqiSettings = {
        title: paymentSettings.title,
        currency: paymentSettings.currency,
        description: paymentSettings.description,
        amount: parseInt(paymentSettings.amount.replace('.', '')),
      };
      window.Culqi.settings(culqiSettings);
      window.Culqi.options({
        lang: 'es',
      });
      window.culqi = () => {
        const token = window.Culqi.token;
        // const error = window.Culqi.error;
        if (token) {
          onSubmit({
            culqi: {
              phone: watch('phone') || '',
              sourceId: token.id,
            },
            name: 'culqi',
          });
        }
        // else {
        //   console.log(error);
        // }
      };
      window.Culqi.open();
      e.preventDefault();
    }
  };

  return (
    <CustomButton
      variant="contained"
      className={classes.confirmButton}
      onClick={handleClick}
      disabled={disabled}
    >
      Proceder a pagar
    </CustomButton>
  );
}

CulqiPaymentButton.propTypes = {
  selectedCard: PropTypes.string.isRequired,
  paymentProvider: PropTypes.object,
  paymentSettings: PropTypes.object,
  watch: PropTypes.func,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  paymentStepAnalyticsEvent: PropTypes.func,
};
